<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container mt-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="blog-slider" >
                <template #default>   <m-content-slider-2 v-bind='{...{"contentType":"post","contentCategory":["header-slider"],"contentCard":"mContentCard910","autoPlay":false,"autoPlayDuration":1000},...{}}' :style='""' class="col-12 p-0 header-slider" ></m-content-slider-2></template>
                </m-div></template>
                </m-div><m-posts-1 v-bind='{...{"cardLink":true,"slicer":"Infinity","contentType":"post","paginate":true,"categoryPanel":true,"flatCategoriesShape":false,"contentCategories":null,"postCard":"mPostCard915","postCardClass":"mb-2 col-lg-4 col-md-6"},...{}}' :style='""' class="my-5 container m-posts-1" >
                <template #p-1>   </template>
                
                <template #p-2>   </template>
                </m-posts-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mContentSlider2 from '@moeinmdn/miw-alpha-components/src/package/Content/Slider/ContentSlider2'; import mPosts1 from '@moeinmdn/miw-alpha-components/src/package/Post/Posts/Posts1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mContentSlider2,mPosts1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
